var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { apiUpdateRfpOfferLock, apiDeleteRfpOfferLock, } from '@/actions/rfpProOfferActions';
import { notifyError } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { createRandomStringId } from '@/utils/libs/uuid/createId';
import { professionalRfpOfferPath } from '@/utils/router/links';
/**
 * 案件提案提出画面 ロック関連の処理
 * @param options
 * @returns
 */
export const useRfpOfferLock = () => {
    var _a;
    // 案件ID
    const { id = '' } = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();
    const unmountRef = useUnmountRef();
    const loadingRef = useRef(false);
    const location = useLocation();
    const locationLockId = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.lockId;
    const lockId = useMemo(() => locationLockId || createRandomStringId(), [locationLockId]);
    /** ロックID 初回設定 */
    const [settingLockId, changeSettingLockId] = useState(() => locationLockId || null);
    /**
     * lock 更新
     */
    const updateLock = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const loading = !!loadingRef.current;
        if (loading) {
            return;
        }
        loadingRef.current = true;
        try {
            const action = apiUpdateRfpOfferLock({ path: { id, lock_id: lockId } }, {});
            yield wrapDispatch(dispatch, action);
        }
        catch (error) {
            if (!unmountRef.current) {
                notifyError();
                history.push(professionalRfpOfferPath(id));
            }
        }
        finally {
            loadingRef.current = false;
        }
    }), [history, id, lockId, dispatch, loadingRef, unmountRef]);
    // ロックID 設定
    useEffect(() => {
        if (!settingLockId && lockId !== locationLockId) {
            history.replace(professionalRfpOfferPath(id), { state: { lockId } });
        }
        if (!settingLockId) {
            changeSettingLockId(lockId);
        }
    }, [history, id, lockId, locationLockId, settingLockId]);
    // ロックID 更新
    useEffect(() => {
        let interval = null;
        if (lockId) {
            interval = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
                yield updateLock();
            }), 10 * 1000);
        }
        return () => {
            // ロックID 解除
            dispatch(apiDeleteRfpOfferLock({ path: { id, lock_id: lockId } }, {}));
            // ロックID 更新解除
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [dispatch, id, lockId, updateLock]);
    return {
        lockId,
    };
};
